import {useEffect} from 'react'
import {ProductEditModalHeader} from './ProductEditModalHeader'
import {useQuery} from 'react-query'
import {isNotEmpty, QUERIES} from '../../../../../../_metronic/helpers'
import {useListView} from '../core/ListViewProvider'
import {getProductById} from '../core/_requests'
import {ProductEditModalForm} from './ProductEditModalForm'

const ProductEditModal = () => {
  useEffect(() => {
    document.body.classList.add('modal-open')
    return () => {
      document.body.classList.remove('modal-open')
    }
  }, [])
  const {itemIdForUpdate, setItemIdForUpdate} = useListView()
  const enabledQuery: boolean = isNotEmpty(itemIdForUpdate)
  const {
    isLoading,
    data: product,
    error,
  } = useQuery(
    `${QUERIES.PRODUCTS_LIST}-product-${itemIdForUpdate}`,
    () => {
      return getProductById(itemIdForUpdate)
    },
    {
      cacheTime: 0,
      enabled: enabledQuery,
      onError: (err) => {
        setItemIdForUpdate(undefined)
      },
    }
  )
  return (
    <>
      <div
        className='modal fade show d-block mp-product-modal mp-catalog-modal'
        id='kt_modal_add_product'
        role='dialog'
        tabIndex={-1}
        aria-modal='true'
      >
        {/* begin::Modal dialog */}
        <div className='modal-dialog modal-dialog-centered modal-xl modal-fullscreen-md-down'>
          {/* begin::Modal content */}
          <div className='modal-content'>
            {!itemIdForUpdate ? (
              <ProductEditModalHeader />
            ) : (
              product && <ProductEditModalHeader product={product} />
            )}
            {/* begin::Modal body */}
            <div className='modal-body scroll-y mp-modal-body'>
              {!itemIdForUpdate ? (
                <ProductEditModalForm invoiceDate='' />
              ) : product ? (
                <ProductEditModalForm product={product} invoiceDate='' />
              ) : (
                <>در حال پردازش...</>
              )}
            </div>
            {/* end::Modal body */}
          </div>
          {/* end::Modal content */}
        </div>
        {/* end::Modal dialog */}
      </div>
      {/* begin::Modal Backdrop */}
      <div className='modal-backdrop fade show'></div>
      {/* end::Modal Backdrop */}
    </>
  )
}

export {ProductEditModal}
